import { supabase } from "../supabase";

export const SITE_SETTINGS_SELECT = Object.freeze({
  ALL: "*",
  AFFILIATE_APPLICATIONS: "affiliate_applications_enabled",
  SENDER_ADDRESS: "from_name, from_company, from_street, from_city, from_state, from_zip",
  SHIPPING: "from_name, from_company, from_street, from_city, from_state, from_zip, default_label_format",
  PAYMENT: "venmo_handle, cashapp_handle, zelle_handle, venmo_enabled, cashapp_enabled, zelle_enabled, payment_timeout_minutes",
  ADMIN_SETTINGS: "orders_email, support_email, marketing_email, site_url, venmo_handle, cashapp_handle, zelle_handle, venmo_enabled, cashapp_enabled, zelle_enabled, contact_phone, contact_address1, contact_address2, contact_city, contact_state, contact_zip, show_hours, business_hours, payment_timeout_minutes, from_name, from_company, from_street, from_city, from_state, from_zip, default_label_format, commission_hold_days",
});
export const BRAND_THEME_SELECT = "*";

const throwOnError = async (query) => {
  const result = await query;
  if (result.error) throw result.error;
  return result;
};

export const getSiteSettings = () => throwOnError(
  supabase.from("site_settings").select(SITE_SETTINGS_SELECT.ALL).single(),
);

export const getAffiliateApplicationSettings = () => throwOnError(
  supabase.from("site_settings").select(SITE_SETTINGS_SELECT.AFFILIATE_APPLICATIONS).eq("id", 1).single(),
);

export const getSenderAddressSettings = () => throwOnError(
  supabase.from("site_settings").select(SITE_SETTINGS_SELECT.SENDER_ADDRESS).single(),
);

export const getShippingSettings = () => throwOnError(
  supabase.from("site_settings").select(SITE_SETTINGS_SELECT.SHIPPING).single(),
);

export const getPaymentSettings = () => throwOnError(
  supabase.from("site_settings").select(SITE_SETTINGS_SELECT.PAYMENT).single(),
);

export const getAdminSettings = () => throwOnError(
  supabase.from("site_settings").select(SITE_SETTINGS_SELECT.ADMIN_SETTINGS).single(),
);

export const updateSiteSettings = (updates) => throwOnError(
  supabase.from("site_settings").update(updates).eq("id", 1),
);

export const listBrandThemes = () => throwOnError(
  supabase.from("brand_themes").select(BRAND_THEME_SELECT).order("created_at", { ascending: false }),
);

export const createBrandTheme = (theme) => throwOnError(
  supabase.from("brand_themes").insert(theme).select(BRAND_THEME_SELECT).single(),
);

export const deleteBrandTheme = (id) => throwOnError(
  supabase.from("brand_themes").delete().eq("id", id),
);
